import { Toast } from '@/utils/index';
// 防抖
	export function debounce(func, delay) {
	  let timer = null;
	  return function() {
	    clearTimeout(timer);
	
	    timer = setTimeout(() => {
	      func.apply(this, arguments);
	    }, delay);
	  };
	}
const check = {
	telphone(data) {
		if (!data) {
			// uni.showToast({
			// 	title: '手机格式有误',
			// 	icon: 'none'
			// })
			Toast('请输入手机号','error')
			return false
		}
		if (!(/^1[23456789]\d{9}$/.test(data))) {
			// uni.showToast({
			// 	title: '手机格式有误',
			// 	icon: 'none'
			// })
			Toast('手机格式有误','error')
			return false
		}
		return true
	},
	// mail(data) {
	// 	if(!(/^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/.test(data))){
	// 		uni.showToast({
	// 			title:'邮箱格式有误',
	// 			icon:'none'
	// 		})
	// 		return false
	// 	}
	// 	return true
	// },
	// idcard(data) {
	// 	if(!(/^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/.test(data))){
	// 		uni.showToast({
	// 			title:'身份证格式有误',
	// 			icon:'none'
	// 		})
	// 		return false
	// 	}
	// 	return true
	// },
	// password(data) {
	// 	if (data.length < 6) {
	// 		uni.showToast({
	// 			title: '秘密不能小于六位',
	// 			icon: 'none'
	// 		})
	// 		return false
	// 	}
	// 	return true
	// },
	code(data) {
		if (data.length != 6) {
			// uni.showToast({
			// 	title: '验证码长度不符',
			// 	icon: 'none'
			// })
			Toast('验证码长度不符','error')
			return false
		}
		return true
	},
	// username(data) {
	// 	if (data == '') {
	// 		uni.showToast({
	// 			title: '用户姓名不能为空',
	// 			icon: 'none'
	// 		})
	// 		return false
	// 	}
	// 	return true

	// },
	// city(data) {

	// 	if (data == '' || data == '请选择收货地址') {
	// 		uni.showToast({
	// 			title: '请选择收货地址',
	// 			icon: 'none'
	// 		})
	// 		return false
	// 	}
	// 	return true


	// },
	// address(data) {

	// 	if (data == '' || data == '请输入详细地址') {
	// 		uni.showToast({
	// 			title: '请输入详细地址',
	// 			icon: 'none'
	// 		})
	// 		return false
	// 	}
	// 	return true
	// }
}
export default check;
// export const Toast = (title, icon = 'success', duration = 1500) => {
// 	uni.showToast({
// 		title,
// 		icon,
// 		// duration
// 	})
// }
